/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useLayoutEffect, useState } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { request } from "../../../utils/request";
import { numeracionTipoDocumento } from "../../../utils/helpers";

const formatFecha = (fecha) => {
	if (!fecha) return "Sin vencimiento";
	const [y, m, d] = fecha.substring(0, 10).split("-");
	return `${d}/${m}/${y}`;
};

const tiposDocEspeciales = [
	{
		value: "factura_proveedor",
		label: "Factura de proveedor",
	},
];

const comprobantesEspeciales = [
	{
		value: "B11",
		label: "B11 - Comprobante de compras",
	},
	{
		value: "B03",
		label: "B03 - Nota de débito",
	},
	{
		value: "B04",
		label: "B04 - Nota de crédito",
	},
];

const Form = ({ numeracion, errors, limites }) => {
	const [form, setForm] = useState({
		id: "",
		tipo_documento: "",
		tipo: "",
		prefijo: "",
		nombre: "",
		numero_inicial: 1,
		numero_siguiente: '',
		numero_final: "",
		fecha_vencimiento: "",
		preferida: 0,
		electronica: 0,
		status: "activo",
		cuenta: {},
	});

	const [tipos_documento, setTiposDocumento] = useState(numeracionTipoDocumento);

	const [tipos, setTipos] = useState([
		// Los que se deben ver siempre
		{
			value: "B01",
			label: "B01 - Crédito Fiscal",
		},
		{
			value: "B02",
			label: "B02 - Consumo",
		},
		{
			value: "B14",
			label: "B14 - Regimen Especial de Tributación",
		},
		{
			value: "B15",
			label: "B15 - Gubernamentales",
		},
		{
			value: "B16",
			label: "B16 - Comprobante para Exportación",
		},
		{
			value: "E31",
			label: "E31 - Crédito Fiscal Electrónico",
		},
		{
			value: "E32",
			label: "E32 - Consumo Electrónica",
		},
        {
			value: "E44",
			label: "E44 - Regímenes Especiales Electrónico",
		},
        {
			value: "E45",
			label: "E45 - Gubernamental Electrónico",
		},
		{
			value: "no_NCF",
			label: "Sin NCF",
		},
	]);

    const [cuentas, setCuentas] = useState([]);

    const getCuentas = async () => {
        const response = await request('cuentas?tipo=BANCARIA');
        return response.data;
    };

	const handleFormInputChange = (input, inputChanged) => {
		if (inputChanged === "tipo_documento") {
			setForm((form) => ({
				...form,
				tipo: "",
			}));
		}

		if (inputChanged === "tipo_documento" && input === "proforma") {
			setForm((form) => ({
				...form,
				tipo: "P",
				[inputChanged]: input,
			}));
			return;
		} else if (
			inputChanged === "tipo_documento" &&
			(input === "cotizacion" || input === "contacto")
		) {
			setForm((form) => ({
				...form,
				tipo: "C",
				[inputChanged]: input,
			}));
			return;
		}

		setForm((form) => ({
			...form,
			[inputChanged]: input,
		}));
	};

	useLayoutEffect(() => {
		if (Object.keys(numeracion).length === 0) return;

		setForm({
			id: numeracion.id || "",
			tipo_documento: numeracion.tipo_documento || "",
			tipo: (numeracion.tipo_documento === "factura_venta" && tipos.findIndex(tipo => tipo.value === numeracion.tipo) === -1) ? "no_NCF" : numeracion.tipo,
			prefijo: numeracion.tipo,
			nombre: numeracion.nombre || "",
			numero_inicial: numeracion.numero_inicial || "",
			numero_siguiente: numeracion.numero_siguiente || "",
			numero_final: numeracion.numero_final || "",
			fecha_vencimiento: numeracion.fecha_vencimiento || "",
			preferida: numeracion.preferida === 'si',
			status: numeracion.status || "activo",
			is_default: numeracion.is_default || false,
			electronica: numeracion.electronica,
            cuenta: numeracion.cuenta ? {label: numeracion.cuenta.nombre, value: numeracion.cuenta.id, cuenta: numeracion.cuenta} : {}
		});

		if (numeracion.id && numeracion.is_default) {
			setTipos((tipos) => [...tipos, ...comprobantesEspeciales]);
			setTiposDocumento((tiposDoc) => [
				...tiposDoc,
				...tiposDocEspeciales,
			]);
		}
	}, [numeracion]);

    useEffect(() => {
        getCuentas().then(data => {
            setCuentas(data.map(c => ({
                label: c.nombre,
                value: c.id,
                cuenta: c
            })));
        });
    }, []);

	return (
		<div className="popup__body">
			<input type="hidden" name="id" value={form.id} />
			<div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label">
						Tipo de documento:
					</label>
				</div>
				<div className="col col-md-8">
					<Select
						name="tipo_documento"
						options={tipos_documento}
						onChange={(e) =>
							handleFormInputChange(e.value, "tipo_documento")
						}
						menuPortalTarget={document.body}
						styles={{
							menuPortal: (base) => ({ ...base, zIndex: 9999 }),
							// control: (styles) => ({
							// 	...styles,
							// 	backgroundColor:
							// 		(form.is_default || form.id) && "#e9ecef",
							// }),
						}}
						value={
							numeracion.id &&
							tipos_documento.find(
								(tipo) => tipo.value === form.tipo_documento
							)
						}
						// menuIsOpen={
						// 	form.is_default || form.id ? false : undefined
						// }
					/>
					{errors.tipo_documento && (
						<small className="help-blockParams form-Text">
							{errors.tipo_documento[0]}
						</small>
					)}
				</div>
			</div>

            {form.tipo_documento == 'cheque' && (<>
				<input
					type="hidden"
					name="electronica"
					value={0}
				/>
                <div className="row form-group">
                    <div className="col col-md-4">
                        <label>Cuenta de Banco</label>
                    </div>
                    <div className="col col-md-8">
                        <Select
                            cacheOptions
                            defaultOptions
                            menuPosition='fixed'
                            menuPlacement='auto'
                            options={cuentas}
                            placeholder="Seleccionar..."
                            onChange={(e) => {
                                handleFormInputChange(e, 'cuenta');
                            }}
                            value={form.cuenta}
                        />
                        <input
                            type="hidden"
                            name="cuenta_id"
                            value={form.cuenta?.value}
                        />
                    </div>
                </div>
            </>)}

			<div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label" for="nombre">Nombre{form.tipo_documento == 'cheque' ? ' chequera' : ''}:</label>
				</div>
				<div className="col col-md-8">
					<input
						type="text"
						name="nombre"
						id="nombre"
						onChange={(e) =>
							handleFormInputChange(e.target.value, "nombre")
						}
						value={form.nombre}
						className="form-control"
						// readOnly={form.is_default}
					/>
					{errors.nombre && (
						<small className="help-blockParams form-Text">
							{errors.nombre[0]}
						</small>
					)}
				</div>
			</div>

			<div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label" for="tipo">{form.tipo_documento === "factura_venta" ? 'Tipo:' : 'Prefijo'}</label>
				</div>
				<div className="col col-md-8">
					{form.tipo_documento === "factura_venta" ? (
						<Select
							name="tipo"
							options={tipos}
							onChange={(e) =>
								handleFormInputChange(e.value, "tipo")
							}
							menuPortalTarget={document.body}
							styles={{
								menuPortal: (base) => ({
									...base,
									zIndex: 9999,
								}),
								// control: (styles) => ({
								// 	...styles,
								// 	backgroundColor:
								// 		form.is_default && "#e9ecef",
								// }),
							}}
							value={
								numeracion.id &&
								tipos.find((tipo) => tipo.value === form.tipo)
							}
							// menuIsOpen={form.is_default ? false : undefined}
						/>
					) : (
						<input
							type="text"
							maxLength={3}
							name="tipo"
							id="tipo"
							onChange={(e) =>
								handleFormInputChange(e.target.value, "tipo")
							}
							value={form.tipo}
							className="form-control"
							// readOnly={form.is_default}
						/>
					)}
					{errors.tipo && (
						<small className="help-blockParams form-Text">
							{errors.tipo[0]}
						</small>
					)}
				</div>
			</div>

			{form.tipo === "no_NCF" && (
				<div className="row form-group">
					<div className="col col-md-4">
						<label className="label form-control-label">
							Prefijo:
						</label>
					</div>
					<div className="col col-md-8">
						<input
							type="text"
							name="prefijo"
							onChange={(e) =>
								handleFormInputChange(e.target.value, "prefijo")
							}
							value={form.prefijo}
							className="form-control"
						/>
						{errors.prefijo && (
							<small className="help-blockParams form-Text">
								{errors.prefijo[0]}
							</small>
						)}
					</div>
				</div>
			)}
            {form.numero_siguiente ? (
                <div className="row form-group">
                    <div className="col col-md-4">
                        <label className="label form-control-label" for="initial_name">
                            Numero Siguiente:
                        </label>
                    </div>
                    <div className="col col-md-8">
                        <input
                            type="number"
                            min={0}
                            name="numero_siguiente"
                            id="initial_name"
                            onChange={(e) =>
                                handleFormInputChange(
                                    e.target.value,
                                    "numero_siguiente"
                                )
                            }
                            value={form.numero_siguiente}
                            className="form-control"
                        />
                        {errors.numero_siguiente && (
                            <small className="help-blockParams form-Text">
                                {errors.numero_siguiente[0]}
                            </small>
                        )}
                    </div>
                </div>
            ) : (
                <div className="row form-group">
                    <div className="col col-md-4">
                        <label className="label form-control-label" for="initial_name">
                            Numero inicial:
                        </label>
                    </div>
                    <div className="col col-md-8">
                        <input
                            type="number"
                            min={0}
                            name="numero_inicial"
                            id="initial_name"
                            onChange={(e) =>
                                handleFormInputChange(
                                    e.target.value,
                                    "numero_inicial"
                                )
                            }
                            value={form.numero_inicial}
                            className="form-control"
                        />
                        {errors.numero_inicial && (
                            <small className="help-blockParams form-Text">
                                {errors.numero_inicial[0]}
                            </small>
                        )}
                    </div>
                </div>
            )}
			{numeracion.id ? (
				// Al editar, el número final y el vencimiento son los del rango
				// activo: solo cambian desde la pestaña Rangos (el backend ignora
				// estos campos en el update, por eso aquí no llevan `name`).
				<>
					<div className="row form-group">
						<div className="col col-md-4">
							<label className="label form-control-label">
								Numero final:
							</label>
						</div>
						<div className="col col-md-8">
							<input
								type="text"
								readOnly
								value={(limites ? limites.numero_final : form.numero_final) || "Sin límite"}
								className="form-control"
							/>
						</div>
					</div>
					{form.tipo_documento != 'cheque' && (
						<div className="row form-group">
							<div className="col col-md-4">
								<label className="label form-control-label">
									Fecha vencimiento:
								</label>
							</div>
							<div className="col col-md-8">
								<input
									type="text"
									readOnly
									value={formatFecha(limites ? limites.fecha_vencimiento : form.fecha_vencimiento)}
									className="form-control"
								/>
								<small className="form-text text-muted">
									Se modifican desde la pestaña Rangos.
								</small>
							</div>
						</div>
					)}
				</>
			) : (<>
			<div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label">
						Numero final:
					</label>
				</div>
				<div className="col col-md-8">
					<input
						type="number"
						min={0}
						name="numero_final"
						onChange={(e) =>
							handleFormInputChange(
								e.target.value,
								"numero_final"
							)
						}
						value={form.numero_final}
						className="form-control"
					/>
					{errors.numero_final && (
						<small className="help-blockParams form-Text">
							{errors.numero_final[0]}
						</small>
					)}
				</div>
			</div>

			{form.tipo_documento != 'cheque' && <div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label">
						Fecha vencimiento:
					</label>
				</div>
				<div className="col col-md-8">
					<input
						type="date"
						name="fecha_vencimiento"
						onChange={(e) =>
							handleFormInputChange(
								e.target.value,
								"fecha_vencimiento"
							)
						}
						value={form.fecha_vencimiento}
						className="form-control"
					/>
					{errors.fecha_vencimiento && (
						<small className="help-blockParams form-Text">
							{errors.fecha_vencimiento[0]}
						</small>
					)}
				</div>
			</div>}

			</>)}

			{form.tipo_documento != 'cheque' && <div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label">
						Preferido:
					</label>
				</div>
				<div className="col col-md-8">
					<div className="form-inline">
						<div className="radio">
							<label className="mr-3">
								<input
									className="mr-1"
									type="radio"
									name="preferida"
									id="optionsRadiosPreferida"
									value={1}
									checked={parseInt(form.preferida) === 1}
									onChange={(e) =>
										handleFormInputChange(
											e.target.value,
											"preferida"
										)
									}
								/>
								Si
							</label>
						</div>
						<div className="radio">
							<label>
								<input
									className="mr-1"
									type="radio"
									name="preferida"
									id="optionsRadiosPreferida"
									value={0}
									checked={parseInt(form.preferida) === 0}
									onChange={(e) =>
										handleFormInputChange(
											e.target.value,
											"preferida"
										)
									}
								/>
								No
							</label>
						</div>
					</div>
					{errors.preferida && (
						<div>
							<small className="help-blockParams form-Text d-block">
								{errors.preferida[0]}
							</small>
						</div>
					)}
				</div>
			</div>}

            {form.tipo_documento != 'cheque' && <div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label">
						Electrónica:
					</label>
				</div>
				<div className="col col-md-8">
					<div className="form-inline">
						<div className="radio">
							<label className="mr-3">
								<input
									className="mr-1"
									type="radio"
									name="electronica"
									value={1}
									checked={parseInt(form.electronica) === 1}
									onChange={(e) =>
										handleFormInputChange(
											e.target.value,
											"electronica"
										)
									}
								/>
								Si
							</label>
						</div>
						<div className="radio">
							<label>
								<input
									className="mr-1"
									type="radio"
									name="electronica"
									value={0}
									checked={parseInt(form.electronica) === 0}
									onChange={(e) =>
										handleFormInputChange(
											e.target.value,
											"electronica"
										)
									}
								/>
								No
							</label>
						</div>
					</div>
					{errors.electronica && (
						<div>
							<small className="help-blockParams form-Text d-block">
								{errors.electronica[0]}
							</small>
						</div>
					)}
				</div>
			</div>}

			{form.tipo_documento == 'cheque' && <input type="hidden" name="preferida" value="0"/>}

			<div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label">Estado:</label>
				</div>
				<div className="col col-md-8">
					<div className="form-inline">
						<div className="radio">
							<label className="mr-3">
								<input
									className="mr-1"
									type="radio"
									name="status"
									id="optionsRadiosActivo"
									value="activo"
									checked={form.status === "activo"}
									onChange={(e) =>
										handleFormInputChange(
											e.target.value,
											"status"
										)
									}
								/>
								Activo
							</label>
						</div>
						<div className="radio">
							<label>
								<input
									className="mr-1"
									type="radio"
									name="status"
									id="optionsRadiosActivo"
									value="inactivo"
									checked={form.status === "inactivo"}
									onChange={(e) =>
										handleFormInputChange(
											e.target.value,
											"status"
										)
									}
								/>
								Inactivo
							</label>
						</div>
					</div>
					{errors.status && (
						<div>
							<small className="help-blockParams form-Text d-block">
								{errors.status[0]}
							</small>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

Form.propTypes = {
	errors: PropTypes.object,
	numeracion: PropTypes.object,
	// Número final y vencimiento del rango activo, refrescados desde la pestaña
	// Rangos sin recargar `numeracion` (eso descartaría lo que se está editando).
	limites: PropTypes.object,
};

export default Form;
